import React from 'react'
import RichText from '@/ui/components/RichText'

import type { ContentBlock as ContentBlockProps } from '@/payload-types'
import { Title } from '@/ui/components/Title'

interface ExtendedContentBlockProps extends ContentBlockProps {
  fixedTitleStyle?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

export const ContentBlock: React.FC<ExtendedContentBlockProps> = ({ text, title, titleHierarchy, fixedTitleStyle }) => {
  return (
    <div>
      <Title
        hierarchy={titleHierarchy}
        className={titleHierarchy === 'h2' ? 'mb-8' : titleHierarchy === 'h6' ? 'mb-2' : 'mb-4'}
        fixedStyle={fixedTitleStyle}
      >
        {title}
      </Title>
      {text && <RichText data={text} enableGutter={false} />}
    </div>
  )
}
